const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export { EMPTY_GUID };

export const CaseStages = {
    Initial: 'Initial',
    FirstLevelAppeal: 'First Level Appeal',
    SecondLevelAppeal: 'Second Level Appeal',
    ClaimMedicalReview: 'Claim Medical Review',
    Reconsideration: 'Reconsideration'
};

export const GeneralConfigs = {
    Spliter: 'Spliter'
};

export const CrmClientsNames = {
    MMM: 'MMM'
};
